import { h as __h } from "preact";
import { Component } from "preact";
import html from "~/util/html.js";
import FocusGroup from "~/component/FocusGroup.js";
import Icon from "~/component/Icon.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./Navigation.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./Navigation.module.css", import.meta.url);
const css = adopt(sheet);

/**
 * @typedef {object} NavLink
 * @property {string} href
 * @property {string} icon
 * @property {string} label
 * @property {number} [badge]
 * @property {boolean} [wild]
 * @property {NavLink[]} [children]
 * @property {() => void} [onClick]
 */

/**
 * @typedef {object} Props
 * @property {NavLink[]} links
 * @property {string} activePath
 */

/** @extends {Component<Props>} */
export default class Navigation extends Component {
  /**
   * @param {NavLink} link
   * @param {string} activePath
   */
  isActive(link, activePath) {
    if (link.wild && activePath.startsWith(link.href)) return true;
    if (activePath === link.href) return true;
    if (link.children) return link.children.some(child => activePath === child.href);
    return false;
  }
  render() {
    const {
      links,
      activePath
    } = this.props;
    return __h(FocusGroup, {
      selector: "a",
      direction: "vertical"
    }, __h("ul", {
      "class": css.navlist
    }, links.map((/** @type {NavLink} */link) => __h("li", {
      "class": css.navitem
    }, __h("a", {
      "class": css.navlink,
      href: link.href,
      "data-active": this.isActive(link, activePath),
      onClick: link.onClick
    }, __h(Icon, {
      name: link.icon,
      label: link.label,
      size: 12
    }), __h("span", {
      "class": css.navlabel,
      "aria-hidden": "true"
    }, link.label), link.badge ? __h("span", {
      "class": css.badge
    }, link.badge) : null), link.children && __h("div", {
      "class": css.subnav
    }, __h("ul", {
      "class": css.subnavlist
    }, link.children.map((/** @type {NavLink} */child) => __h("li", {
      "class": css.subnavitem
    }, __h("a", {
      "class": css.navlink,
      href: child.href,
      "data-active": activePath === child.href,
      onClick: child.onClick
    }, __h(Icon, {
      name: child.icon,
      label: child.label,
      size: 12
    }), __h("span", {
      "class": css.navlabel,
      "aria-hidden": "true"
    }, " ", child.label, " "))))))))));
  }
}